import { getConnectionDomain } from '../domains';

export default function selector(state) {
  return getConnectionDomain(state);
}



// WEBPACK FOOTER //
// ./src/store/models/connectionStatus.js